import { BaseService } from './baseService';

class AutomaticPaymentMethodsService extends BaseService<
	AutomaticPaymentMethod,
	'automaticPaymentMethodID',
	'automaticPaymentMethods'
> {
	constructor() {
		super(
			'automaticPaymentMethodID',
			'automaticPaymentMethod',
			'automaticPaymentMethods',
		);
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new AutomaticPaymentMethodsService();
